export default "__VITE_ASSET__c672163c__"